import { Card, SimpleGrid, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AttachmentList } from '../../components/Attachments';
import { useSession } from '../../app/session';
import { useAircraft } from './AircraftDetailLayout';

export function AircraftDocumentsTab() {
  const { t } = useTranslation();
  const aircraft = useAircraft();
  const { can } = useSession();

  return (
    <SimpleGrid cols={{ base: 1, lg: 2 }} spacing="md">
      <Card p="md">
        <Title order={3} mb={4}>
          {t('nav.documents')}
        </Title>
        <Text fz="sm" c="dimmed" mb="md">
          {t('maintenance.ADMINISTRATION')}
        </Text>
        <AttachmentList
          target="aircraft.aircraft"
          targetId={aircraft.id}
          canEdit={can('attachments.add')}
        />
      </Card>

      {aircraft.components.map((component) => (
        <Card key={component.id} p="md">
          <Title order={3} mb={4}>
            {component.name || component.kind}
          </Title>
          <Text fz="sm" c="dimmed" mb="md">
            {component.serial_number}
          </Text>
          <AttachmentList
            target="aircraft.aircraftcomponent"
            targetId={component.id}
            canEdit={can('attachments.add')}
            compact
          />
        </Card>
      ))}
    </SimpleGrid>
  );
}
